/**
 * Customizable Dashboard — grid + schema constants.
 *
 * Single source of truth shared by the API (validation/normalization) and the
 * React frontend (react-grid-layout rendering). Kept free of any framework or
 * Node.js dependency so it is browser-safe (`@codemerlin/shared` browser entry).
 */
/** Current persisted layout schema version. Bump when the shape changes and add a migration. */
export const DASHBOARD_LAYOUT_SCHEMA_VERSION = 2;
/** Canonical (desktop / `lg`) grid column count. */
export const DASHBOARD_GRID_COLUMNS = 12;
/** react-grid-layout row height, in pixels. */
export const DASHBOARD_GRID_ROW_HEIGHT = 30;
/** react-grid-layout horizontal + vertical margin, in pixels. */
export const DASHBOARD_GRID_MARGIN_PX = 16;
/** Responsive breakpoint pixel thresholds (mirrors Tailwind-ish desktop/tablet/mobile). */
export const DASHBOARD_GRID_BREAKPOINTS = {
    lg: 1024,
    md: 768,
    sm: 0,
};
/** Column counts per breakpoint. Smaller breakpoints are derived, never persisted. */
export const DASHBOARD_GRID_COLS = {
    lg: DASHBOARD_GRID_COLUMNS,
    md: DASHBOARD_GRID_COLUMNS,
    sm: 1,
};
//# sourceMappingURL=constants.js.map